<ngx-charts-area-chart-stacked
  [view]="view"
  [scheme]="colorScheme"
  [schemeType]="schemeType"
  [animations]="enableAnimations"
  [legend]="legend?.visible || true"
  [legendPosition]="legend?.position || 'right'"
  [legendTitle]="legend?.title || 'Legend'"
  [showGridLines]="showGridLines"
  [xAxis]="axis?.showXAxis"
  [yAxis]="axis?.showYAxis"
  [showXAxisLabel]="axis?.xAxisLabel"
  [showYAxisLabel]="axis?.yAxisLabel"
  [xAxisLabel]="axis?.xAxisLabel"
  [yAxisLabel]="axis?.yAxisLabel"
  [curve]="curve"
  [timeline]="timeline"
  [results]="data"
  [tooltipDisabled]="tooltipDisabled"
  (select)="onSelect($event)"
></ngx-charts-area-chart-stacked>
